import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { stories as mockStories } from '../mock';
import { ArrowUpRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Stories() {
  const [stories, setStories] = useState(mockStories);

  useEffect(() => {
    axios
      .get(`${API}/api/site/articles`)
      .then((r) => {
        if (r.data?.length) {
          setStories(
            r.data.slice(0, 3).map((a, i) => ({
              id: i + 1,
              slug: a.slug,
              tag: a.tag,
              title: a.title,
              excerpt: a.excerpt,
              image: a.image,
            }))
          );
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className="section-pad bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-[0.25em] text-px-red font-semibold mb-3">
              NEWS & ARTIKEL
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-neutral-900">
              Temukan artikel kami.
            </h2>
          </div>
          <Link
            to="/articles"
            data-testid="home-stories-all"
            className="inline-flex items-center gap-1 text-sm font-semibold text-neutral-900 border-b-2 border-px-red pb-1 hover:gap-2 transition-all"
          >
            Semua artikel <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stories.map((s) => (
            <Link
              key={s.id}
              to={`/articles/${s.slug}`}
              data-testid={`home-story-${s.slug}`}
              className="group block hover-lift bg-neutral-50 rounded-2xl overflow-hidden"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <p className="text-[11px] tracking-[0.25em] text-px-red font-bold mb-3">
                  {s.tag}
                </p>
                <h3 className="font-display text-xl font-bold text-neutral-900 mb-2 leading-snug group-hover:text-px-red transition-colors">
                  {s.title}
                </h3>
                <p className="text-sm text-neutral-600 leading-relaxed line-clamp-3">
                  {s.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
